import 'antd/es/dropdown/style';
import _Dropdown from 'antd/es/dropdown';
import 'antd/es/avatar/style';
import _Avatar from 'antd/es/avatar';
import 'antd/es/menu/style';
import _Menu from 'antd/es/menu';
import _extends from 'babel-runtime/helpers/extends';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { useEffect, useState } from 'react';
import { UserOutlined } from '@ant-design/icons';

import cx from 'classnames';
import { getToken, getCompanyId, getInformOutLines, searchNotice, readedNotice, getSpecialKeys, getServiceList, checkIsAdminBoot } from 'jcb-token-kit';
import { customNavCompanyIds } from '../utils/constant';
import CustomMsg from './CustomMsg';
import logoutImg from '../assets/logout.png';
import './CustomHeader.css';

var searchInitData = {
  informType: 'SYSTEM_INFORM',
  status: 'NOT_READ',
  serviceType: null,
  page: 0,
  size: 5
};
var CustomHeader = function CustomHeader(_ref) {
  var _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === undefined ? 1000 : _ref$minWidth,
      _ref$avatar = _ref.avatar,
      avatar = _ref$avatar === undefined ? '' : _ref$avatar,
      userName = _ref.userName;

  // logo
  var B3 = getSpecialKeys('B3');

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      customCompany = _useState2[0],
      setCustomCompany = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      menuList = _useState4[0],
      setMenuList = _useState4[1];

  var _useState5 = useState({
    id: 'home',
    name: '首页',
    serviceType: 0,
    link: null,
    openNew: false
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      homeItem = _useState6[0],
      setHomeItem = _useState6[1];

  var _useState7 = useState({
    id: 'manage',
    name: '账号管理',
    serviceType: 0,
    link: null,
    openNew: false
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      manageItem = _useState8[0],
      setManageItem = _useState8[1];

  var navStyles = {
    background: localStorage.getItem('themeColor'),
    borderBottom: 'solid 1px ' + localStorage.getItem('themeColor')
  };

  var _useState9 = useState(0),
      _useState10 = _slicedToArray(_useState9, 2),
      noticNum = _useState10[0],
      setNoticNum = _useState10[1];

  var getNotice = function getNotice() {
    getInformOutLines().then(function (_ref2) {
      var allCount = _ref2.allCount;

      setNoticNum(allCount);
    });
  };
  useEffect(function () {
    getNotice();
  }, []);
  useEffect(function () {
    // 前期写死的定制系统企业id
    var companys = customNavCompanyIds.filter(function (v) {
      return v.id === getCompanyId();
    });
    if (companys.length > 0) {
      setCustomCompany(companys[0]);
    } else {
      // 后期优化不再写死
      getServiceList(getCompanyId()).then(function (data) {
        var homePage = data.filter(function (v) {
          return v.serviceType === -1;
        });
        var dygcDomain = data.filter(function (v) {
          return v.serviceType === 0;
        });
        if (homePage.length > 0) {
          localStorage.setItem('dygchome', homePage[0].serviceDomain);
        }
        if (dygcDomain.length > 0) {
          localStorage.setItem('dygcDomain', dygcDomain[0].serviceDomain);
        }
        var menus = (data || []).filter(function (v) {
          return v.locks && (v.locks[0] || v.locks[0] === 'true') || v.serviceType === 0;
        }).map(function (v) {
          if (v.serviceType === 0) {
            // 基础模块
            setManageItem(_extends({}, manageItem, {
              link: v.serviceDomain,
              openNew: v.openNew
            }));
            setHomeItem(_extends({}, homeItem, {
              link: v.serviceDomain,
              openNew: v.openNew
            }));
            return null;
          }
          return _extends({}, v, {
            id: v.serviceType,
            link: v.serviceDomain,
            name: v.names[0],
            openNew: v.openNew
          });
          // if (v.serviceType === 13) {
          //   return {
          //     id: 'sb',
          //     name: '材料申报',
          //     serviceType: 13,
          //     link: v.serviceDomain,
          //   };
          // }
          // if (v.serviceType === 20) {
          //   return {
          //     id: 'show',
          //     name: '数据大屏',
          //     serviceType: 20,
          //     link: v.serviceDomain,
          //   };
          // }
          // if (v.serviceType === 2) {
          //   return {
          //     id: 'jcb',
          //     name: '实地检查',
          //     serviceType: 2,
          //     link: v.serviceDomain,
          //   };
          // }
          // if (v.serviceType === 1) {
          //   return {
          //     id: 'survey',
          //     name: '问卷调查',
          //     serviceType: 1,
          //     link: v.serviceDomain,
          //   };
          // }
          // if (v.serviceType === 4) {
          //   return {
          //     id: 'pxb',
          //     name: '调研培训',
          //     serviceType: 4,
          //     link: v.serviceDomain,
          //   };
          // }
        });
        setMenuList(menus.filter(function (v) {
          return v;
        }).sort(function (v, m) {
          return v.sort - m.sort;
        }));
      });
    }
  }, []);

  useEffect(function () {
    if (customCompany) {
      var sysMenus = customCompany.sysMenus;

      getServiceList(getCompanyId()).then(function (data) {
        var homePage = data.filter(function (v) {
          return v.serviceType === -1;
        });
        var dygcDomain = data.filter(function (v) {
          return v.serviceType === 0;
        });
        if (homePage.length > 0) {
          localStorage.setItem('dygchome', homePage[0].serviceDomain);
        }
        if (dygcDomain.length > 0) {
          localStorage.setItem('dygcDomain', dygcDomain[0].serviceDomain);
        }

        sysMenus.forEach(function (v) {
          data.some(function (d) {
            if (v.serviceType === d.serviceType) {
              v.link = d.serviceDomain;
              return true;
            }
          });
        });
      });
      checkIsAdminBoot(getCompanyId()).then(function (v) {
        setMenuList(!v ? sysMenus.filter(function (i) {
          return i.serviceType !== 1;
        }) : sysMenus);
      });
    }
  }, [customCompany]);

  // 退出登录
  var onLogoutHandler = function onLogoutHandler() {
    window.location.href = localStorage.getItem('dygchome');
    removeToken();
    sessionStorage.clear();
    clearToken();
  };
  var renderName = function renderName() {
    if (userName && userName.length > 2) {
      return userName.substring(userName.length - 2, userName.length);
    }
    return userName || '';
  };

  var isActiveMenu = function isActiveMenu(id, type) {
    return id === 'jcb' || type === 2 ? 'custom-menu-item-active' : 'custom-menu-item';
  };

  // 系统跳转
  var onClickSysMenu = function onClickSysMenu(menu) {
    // 账号管理
    if (menu.id === 'manage') {
      window.location.href = menu.link + '/user/staff/list?companyid=' + (getCompanyId() || 0) + '&token=' + getToken();
    } else if (menu.id === 'pxb' || menu.serviceType === 4) {
      window.location.href = menu.link + '/?role=learner&companyid=' + (getCompanyId() || 0) + '&token=' + getToken();
    } else if (menu.id === 'home') {
      window.location.href = menu.link + '/user/home?companyid=' + (getCompanyId() || 0) + '&token=' + getToken();
    } else {
      if (menu.open || menu.openNew) {
        window.open(menu.link + '?year=2019&companyid=' + (getCompanyId() || 0) + '&token=' + getToken());
      } else {
        window.location.href = menu.link + '?year=2019&companyid=' + (getCompanyId() || 0) + '&token=' + getToken();
      }
    }
  };

  return React.createElement(
    'div',
    { className: 'custom-menu--custom-menu' },
    React.createElement(
      'div',
      {
        style: _extends({
          minWidth: minWidth + 'px',
          left: 0
        }, navStyles),
        className: cx({
          'navbar-container--custom-menu': true,
          'fixed-nav': true
        })
      },
      React.createElement(
        'div',
        { className: 'left-box' },
        React.createElement(
          'div',
          { className: 'left-menu' },
          React.createElement('img', { className: 'logo', src: B3.value, height: '32', width: '359' })
        ),
        React.createElement(
          'div',
          { className: 'custom-menu' },
          [homeItem].concat(menuList.concat([manageItem])).map(function (item) {
            if (item && item.link) {
              return React.createElement(
                'div',
                {
                  className: isActiveMenu(item.id, item.serviceType),
                  key: item.id,
                  onClick: function onClick() {
                    onClickSysMenu(item);
                  }
                },
                item.name
              );
            }
          })
        )
      ),
      React.createElement(
        'div',
        { className: 'right-menu' },
        React.createElement(
          'div',
          {
            className: 'return-btn-con download-btn-con',
            style: { marginRight: '10px' }
          },
          React.createElement(CustomMsg, {
            token: getToken(),
            searchInitData: searchInitData,
            companyid: getCompanyId() || 0,
            noticNum: noticNum,
            getNotice: getNotice,
            getInformOutLines: getInformOutLines,
            searchNotice: searchNotice,
            readedNotice: readedNotice
          })
        ),
        React.createElement(
          _Dropdown,
          {
            overlayClassName: 'dropdown--jcb-menu',
            overlay: React.createElement(
              _Menu,
              {
                style: {
                  width: '120px',
                  height: '54px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '10px 0'
                }
              },
              React.createElement(
                _Menu.Item,
                { key: 'logout', onClick: onLogoutHandler },
                React.createElement(
                  'div',
                  { className: 'logout-area-custom' },
                  React.createElement('img', {
                    style: { marginRight: '7px' },
                    src: logoutImg,
                    height: '15'
                  }),
                  '\u9000\u51FA\u767B\u5F55'
                )
              )
            )
          },
          React.createElement(
            'div',
            { style: { cursor: 'pointer' } },
            avatar ? React.createElement(_Avatar, {
              icon: React.createElement(UserOutlined, null),
              style: { marginRight: '8px' },
              src: avatar
            }) : React.createElement(
              'div',
              {
                className: 'photo-box-custom',
                style: { color: '' + localStorage.getItem('themeColor') }
              },
              renderName()
            )
          )
        ),
        userName && React.createElement(
          'span',
          { className: 'user' },
          userName
        )
      )
    ),
    React.createElement('div', { style: { minWidth: minWidth + 'px' }, className: 'shadow' })
  );
};

__signature__(CustomHeader, 'useState{[customCompany, setCustomCompany](null)}\nuseState{[menuList, setMenuList]([])}\nuseState{[homeItem, setHomeItem]({\n    id: \'home\',\n    name: \'\u9996\u9875\',\n    serviceType: 0,\n    link: null,\n    openNew: false,\n  })}\nuseState{[manageItem, setManageItem]({\n    id: \'manage\',\n    name: \'\u8D26\u53F7\u7BA1\u7406\',\n    serviceType: 0,\n    link: null,\n    openNew: false,\n  })}\nuseState{[noticNum, setNoticNum](0)}\nuseEffect{}\nuseEffect{}\nuseEffect{}');

var _default = CustomHeader;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(searchInitData, 'searchInitData', 'src/components/CustomHeader.js');
  reactHotLoader.register(CustomHeader, 'CustomHeader', 'src/components/CustomHeader.js');
  reactHotLoader.register(_default, 'default', 'src/components/CustomHeader.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();